import './index.css'
import './styles/common.scss'

import Amplify from 'aws-amplify'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import store from './store'

import awsconfig from './aws-exports'
import ServerErrorMaintenance from './containers/system/Maintenance'
import CognitoAuthProvider from './contexts/AuthContext'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'

Amplify.configure(awsconfig)

ReactDOM.render(
  <React.StrictMode>
    <CognitoAuthProvider amplifyConfig={awsconfig}>
      <Provider store={store}>
        <Router>
          <Switch>
            {/* <Route exact path={'/'} component={TopPageView} /> */}
            <Route exact component={ServerErrorMaintenance} />
          </Switch>
        </Router>
      </Provider>
    </CognitoAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
